import {FloorPlanViewActions, FloorPlanViewActionTypes} from '../actions/floor-plan-view.actions';
import {AirComponentType} from '../../afb-api/enums/air-component-type.enum';
import {UpdateSelectedFloorPayload} from '../models/floor-plan';

export interface State {
  selectedFloorId: string | null;
  selectedAirComponent: AirComponentType | null;
}

export const initialState: State = {
  selectedFloorId: null,
  selectedAirComponent: AirComponentType.Score
};

export function reducer(state = initialState, action: FloorPlanViewActions): State {
  switch (action.type) {

    case FloorPlanViewActionTypes.UpdateSelectedFloor: {
      const updateSelectedFloorPayload: UpdateSelectedFloorPayload = action.payload;
      return {
        ...state,
        selectedFloorId: updateSelectedFloorPayload.floorId
      };
    }

    case FloorPlanViewActionTypes.DeselectFloorSuccess: {
      return {
        ...state,
        selectedFloorId: null
      };
    }

    case FloorPlanViewActionTypes.UpdateSelectedAirComponent: {
      const selectedAirComponentType: AirComponentType = action.payload;
      return {
        ...state,
        selectedAirComponent: selectedAirComponentType
      };
    }

    default:
      return state;
  }
}

export const selectedFloorId = (state: State) => state.selectedFloorId;
export const selectedAirComponent = (state: State) => state.selectedAirComponent;
